import { useState } from "react";
import { useLoginContext } from "@/features/auth/contexts/login-context";

export const useUpdateIdStates = () => {

  const [newEmail, setNewEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  //const [emailConfirmError, setEmailConfirmError] = useState("");

  // 更新ボタン有効フラグ
  const [isActiveUpdateButton, setIsActiveUpdateButton] = useState(false);

  // 確認ダイアログ表示フラグ
  const [isShowConfirmDialog, setIsShowConfirmDialog] = useState(false);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
  });

  return {
    newEmail,
    setNewEmail,
    emailError,
    setEmailError,
    //emailConfirm,
    //setEmailConfirm,
    //emailConfirmError,
    //setEmailConfirmError,
    isActiveUpdateButton,
    setIsActiveUpdateButton,
    isShowConfirmDialog,
    setIsShowConfirmDialog,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
